import { BaseLogger, NoOpLogger } from '../classes/Logger';
import { PlayerConfigLogEvent } from '../constants/logEvents';
import { TranscriptReturn } from '../types/transcript-types';
import { getRecordingSubtitleUrl, getTranscriptDataInRequiredFormat, getFilteredWords } from '../utils/transcriptUtils';

export function fetchTranscript({
  cacheSuffix,
  event,
  broadcast,
  clip_start_time,
  clip_end_time,
  onError,
  logger = new NoOpLogger()
}: {
  cacheSuffix: string;
  event: string;
  broadcast: string;
  clip_start_time?: number;
  clip_end_time?: number;
  onError: (error: string) => void;
  logger?: BaseLogger;
}): Promise<TranscriptReturn> {
  const t = Date.now();
  const url = getRecordingSubtitleUrl(event, broadcast)(`transcript.json?${cacheSuffix}`);
  logger.info(
    {
      event: PlayerConfigLogEvent.TRANSCRIPT_OUTBOUND,
      url
    },
    'Transcript outbound request'
  );
  return fetch(url, { cache: 'force-cache' })
    .then(res => {
      if (res.status >= 400) {
        onError("Oops! We're having trouble loading the transcript. Please check your connection and try again.");
      }
      logger.info(
        {
          event: PlayerConfigLogEvent.TRANSCRIPT_RESPONSE,
          durationMs: Date.now() - t
        },
        'Transcript response'
      );
      return res.json();
    })
    .then(words => {
      if (!Array.isArray(words)) {
        return {
          transcript: [],
          fullTranscript: []
        };
      }

      const fullTranscript = getTranscriptDataInRequiredFormat(words);
      const filteredWords = getFilteredWords(words, clip_start_time, clip_end_time);

      return {
        transcript: getTranscriptDataInRequiredFormat(filteredWords),
        fullTranscript
      };
    });
}
